import type { SeoLandingConfig } from "../types";
import { crediarioLojaDeCalcados } from "./crediarioLojaDeCalcados";
import { crediarioLojaDeRoupas } from "./crediarioLojaDeRoupas";
import { integracaoLinx } from "./integracaoLinx";
import { pixNoCrediario } from "./pixNoCrediario";
import { recuperacaoDeCredito } from "./recuperacaoDeCredito";
import { sistemaDeCobranca } from "./sistemaDeCobranca";
import { whatsappParaRedeDeLojas } from "./whatsappParaRedeDeLojas";

/**
 * Todas as LPs de SEO no ar. Cada uma também precisa de uma entrada em
 * `manifest.json` (lido pelo prerender e pelo `llms.txt`), em
 * `public/sitemap-pages.xml` e nos rewrites do `vercel.json` — o teste
 * `seoLandingRegistry.test.ts` falha se alguma faltar.
 */
export const SEO_LANDINGS: SeoLandingConfig[] = [
  crediarioLojaDeCalcados,
  integracaoLinx,
  pixNoCrediario,
  sistemaDeCobranca,
  crediarioLojaDeRoupas,
  recuperacaoDeCredito,
  whatsappParaRedeDeLojas,
];
